import { render, staticRenderFns } from "./DeleteArticleDialog.vue?vue&type=template&id=daa6be3a&"
import script from "./DeleteArticleDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteArticleDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports